import { Box, Grid, Typography } from '@mui/material';
import LoginForm from '../../components/Auth/LoginForm';


const LoginPage = () => {

    return (
        <Box sx={{
            backgroundColor: 'background.paper',
            justifyContent: 'center',
            margin: 'auto',
            marginTop: '3rem',
            marginBottom: '3rem',
            maxWidth: '30rem',
            minHeight: 'calc(100vh - 287px)',


        }}>
            <Grid container justifyContent={'center'} p={3}>
                <Box>
                    <Typography component="h2" sx={{
                        fontSize: '1.5rem',
                        lineHeight: '1.5',
                        fontFamily: '"DM Sans", sans-serif',
                        fontWeight: 700,
                        margin: 0,
                        textAlign: 'center',
                        maxWidth: '25rem',
                    }}>
                        Bienvenido a PyM Gestiones.
                    </Typography>
                    <Typography component="h6" sx={{
                        fontSize: '1rem',
                        lineHeight: '1.5',
                        fontFamily: '"DM Sans", sans-serif',
                        fontWeight: 400,
                        margin: 0,
                        textAlign: 'center',
                    }}>
                        Ingresá tus datos para comenzar a pedir y gestionar tus informes.
                    </Typography>

                    <LoginForm />
                </Box>
            </Grid>

        </Box>);
}

export default LoginPage;